import React from 'react';
import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import { connect } from 'react-redux';
import get from 'lodash.get';
import ExtraUserInformationFormModal from './ExtraUserInformationFormModal';
import styles from './ExtraUserInformation.css';
import NorthEastAdditionalInformationFields from './NorthEastAdditionalInformationfields';

const NorthEastExtraInformation = ({ ...props }) => (<ExtraUserInformationFormModal
    title="Welcome to Northeast Wisconsin Technical College!"
    subtitle="Please provide some additional information below to continue."
    {...props}
>
    <NorthEastAdditionalInformationFields />
    <p className={styles.info}>
        {'By creating a user account, I give consent to be contacted by mail, email and telephone (including auto-dialed, prerecorded and/or text messaging) to the designated number and contact information I have provided to receive information. I also give consent to share my information and results with counselors. Standard messaging and data rates may apply based on the plan you have with your mobile carrier.'}
    </p>
</ExtraUserInformationFormModal>);

export default compose(
    connect(({ me, auth }) => ({
        show: (me && (
            !me.dateOfBirth
            || !me.mobilePhone
        ) && Number(auth.level) === 5),
        initialValues: {
            dateOfBirth: get(me, 'dateOfBirth'),
            mobilePhone: get(me, 'mobilePhone'),
        },
    })),
    branch(
        ({ show }) => !show,
        renderNothing,
    ),
)(NorthEastExtraInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/NorthEastExtraInformation.js